import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute, NavigationStart, Router} from "@angular/router";
import {PageHeader, SettingsService} from "../../service/settings.service";
import {filter} from "rxjs/operators";


@Component({
  selector: 'app-settings-page',
  templateUrl: './settings.page.html',
  styleUrls: ['settings.page.scss']
})
export class SettingsPage extends CorePage implements OnInit {

  activeTab3: number | undefined = 0;
  text: string | null = null;

  // header: PageHeader | undefined;

  constructor(
    protected settingService: SettingsService,
    protected override route: ActivatedRoute,
    protected router: Router,
  ) {
    super(route);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.initComponent();
  }

  initComponent() {

    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => {
        this.settingService.resetHeader(); // reset before every route
      });

    this.refreshComponent();
  }


  refreshComponent() {

    this.initialized = true;
  }

}
